import { __ } from '@wordpress/i18n';
import { PanelBody} from '@wordpress/components';
import { SlideButton } from '@vayu-blocks/global';
import { VayuBlocksToggleControl, IconSelector, HeightControl, VayuBlocksSelectControl} from '@vayu-blocks';
import {
  __experimentalToggleGroupControl as ToggleGroupControls,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
} from '@wordpress/components';
import { Icon,justifyLeft, justifyRight } from '@wordpress/icons';

const Faq = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

	const handleiconalignment = (value) => {
		if(value==='left'){
			setAttributes({iconalignment:value, iconleft:{Desktop: '1%', Tablet:'1%', Mobile:'1%'}})
		}else if(value === 'right'){
			setAttributes({iconalignment:value, iconleft:{Desktop: '93%', Tablet:'93%', Mobile:'93%'} })
		}
	};

	return (
		<>
			<PanelBody
				title={__('Faq', 'vayu-blocks')}
				opened={openPanels['faq-panel']}
				onToggle={() => onTogglePanel('faq-panel')}
			>

				<SlideButton  
					button={{ accordation: "Accordion", grid: "Grid" }}
					onChange={(value)=>setAttributes({showtype: value})}
					defaultValue={attributes.showtype}
				/>
				
				{attributes.showtype === 'accordation' && (
					<div className='vb-accordation-toggle'>
						<VayuBlocksToggleControl
							label={__('Collapse other items', 'vayu-blocks')}
							checked = {attributes.collapseall}
							onChange={(value)=> setAttributes({collapseall: value})}
						/>

						{attributes.collapseall && (

							<VayuBlocksToggleControl
								label={__('Expand First Item', 'vayu-blocks')}
								checked = {attributes.expandfirst}
								onChange={(value)=> setAttributes({expandfirst: value})}
							/>
						)}

						<VayuBlocksToggleControl
							label={__('Enable Toggle', 'vayu-blocks')}
							checked = {attributes.enabletoggle}
							onChange={(value)=> setAttributes({enabletoggle: value})}
						/>

						<VayuBlocksSelectControl
							label={__('Click Event', 'vayu-blocks')}
							value={attributes.click}
							options={[
								{ label: __('Title', 'vayu-blocks'), value: 'question' },
								{ label: __('Icon', 'vayu-blocks'), value: 'icon' },
								{ label: __('Both', 'vayu-blocks'), value: 'both' },
							]}
							onChange={(value)=> setAttributes({click:value})}
						/>

						<p class="help-button" >Only icon is clickable in editor; full toggle works on front end.</p>

					</div>
				)}
			
			</PanelBody>
			
			{attributes.showtype != 'grid' && (
					<PanelBody
						title={__('Icons', 'vayu-blocks')}
						opened={openPanels['faq-icon']}
						onToggle={() => onTogglePanel('faq-icon')}
					>

						<div style={{ marginBottom: '10px' }}>
							<p style={{ fontWeight: '500', marginBottom: '6px' }}>{__('Active Icon', 'vayu-blocks')}</p>
							<IconSelector
								value={{iconName: attributes.activeiconName}}
								onChange={(val) =>setAttributes({activeiconName: val.iconName})}
							/>
						</div>

						<div>
							<p style={{ fontWeight: '500', marginBottom: '6px' }}>{__('Inactive Icon', 'vayu-blocks')}</p>
							<IconSelector
								value={{iconName: attributes.inactiveiconName}}
								onChange={(val) =>setAttributes({inactiveiconName: val.iconName})}
							/>
						</div>

						<div className='alignment-component-vb vb-alignemnt-faq'>
							<ToggleGroupControls
								__next40pxDefaultSize={true}
								__nextHasNoMarginBottom={true}
								isBlock
								label={__('Icon alignment', 'vayu-blocks')}
								value={ attributes.iconalignment}
								onChange={(value)=> handleiconalignment(value)}
							>
								<ToggleGroupControlOptionIcon
									icon={<Icon icon={ justifyLeft } />}
									label="left"
									value="left"
								/>
								<ToggleGroupControlOptionIcon
									icon={<Icon icon={ justifyRight } />}
									label="right"
									value="right"
								/>
							</ToggleGroupControls>
						</div>

						<HeightControl
							label={__('Top', 'vayu-blocks')}
							value={ attributes.icontop }
							onChange={ (value) => setAttributes({icontop: value }) }
							responsive={true}
						/>

						<HeightControl
							label={__('Left', 'vayu-blocks')}
							value={ attributes.iconleft }
							onChange={ (value) => setAttributes({iconleft: value }) }
							responsive={true}
						/>

					</PanelBody>
			)}
		</>
	);
};

export default Faq;